import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BACKEND_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("contentos_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    if (status === 401 && !window.location.pathname.startsWith("/auth")) {
      localStorage.removeItem("contentos_token");
      localStorage.removeItem("contentos_user");
      window.location.href = "/auth";
    }
    if (status === 402 && !window.location.pathname.startsWith("/app/billing")) {
      // Entitlement missing — send user to the billing page so they can upgrade.
      // Small delay lets the calling code still surface the toast.
      setTimeout(() => { window.location.href = "/app/billing"; }, 800);
    }
    return Promise.reject(err);
  }
);
